import { baseRoutes } from '@routes/helpers/baseRoutes.ts';
import { routesPaths } from '@routes/helpers/constants.ts';
import { AppRouteConfig } from '@routes/route.ts';

export const insightsRoutes: ReadonlyArray<AppRouteConfig> = [
  {
    path: baseRoutes.insights.root,
    lazyImport: () => import('../../domains/protected/insights/InsightsRoute.tsx'),
    requiresAuth: true,
    resourceId: 'insight',
    children: [
      {
        index: true,
        lazyImport: () => import('../../domains/protected/insights/pages/InsightsListRoute.tsx'),
        nav: {
          hideBack: true,
          breadcrumbKey: 'list'
        }
      },
      {
        path: baseRoutes.insights.details,
        lazyImport: () => import('../../domains/protected/insights/pages/InsightDetailsRoute.tsx'),
        nav: {
          backTo: routesPaths.insights.root,
          breadcrumbKey: 'details'
        }
      },
      {
        path: '*',
        redirectTo: routesPaths.insights.root
      }
    ]
  }
];
